import ApiService from "@/common/api/api.service";

export const BMService = {
    list(page=1, itemsPerPage=10) {
        ApiService.setHeader()
        return ApiService.get(`bm?page=${page}&itemsPerPage=${itemsPerPage}`)
    },
    
    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`bm?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },

    listCashFlow(id,page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`bm/${id}/cashFlow?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },


    get(slug) {
        ApiService.setHeader()
        return ApiService.get('bm', slug)
    },
    getBalance(slug) {
        ApiService.setHeader()
        return ApiService.get(`bm/${slug}/balances`)
    },
    getDayOffs(slug) {
        ApiService.setHeader()
        slug = slug + "/days-off"
        return ApiService.get('bm', slug)
    },
    create(data) {
        ApiService.setHeader()
        return ApiService.post('bm', data)
    },
    getAssistants() {
        ApiService.setHeader()
        return ApiService.get(`bm/assistants`)
    },
    getServices(id) {
        ApiService.setHeader()
        return ApiService.get(`bm/${id}/services`)
    },
    addService(id, data) {
        ApiService.setHeader()
        return ApiService.post(`bm/${id}/services`, data)
    },
    addPayment(id, data) {
        ApiService.setHeader()
        return ApiService.post(`bm/${id}/cashFlow`, data)
    },
    updateService(id, data) {
        ApiService.setHeader()
        return ApiService.put(`bm/${id}/services`, data)
    },
    deleteService(id, serviceID) {
        ApiService.setHeader()
        return ApiService.delete(`bm/${id}/services/${serviceID}`)
    },

    getWorkDays(id) {
        ApiService.setHeader()
        return ApiService.get(`bm/${id}/workDays`)
    },
    addWorkDay(id, data) {
        ApiService.setHeader()
        return ApiService.post(`bm/${id}/workDays`, data)
    },
    updateWorkDay(id, data) {
        ApiService.setHeader()
        return ApiService.put(`bm/${id}/workDays`, data)
    },
    deleteWorkDay(bmID, id) {
        ApiService.setHeader()
        return ApiService.delete(`bm/${bmID}/workDays/${id}`)
    },
    
    
    
    addDayOff(id, data) {
        ApiService.setHeader()
        return ApiService.post(`bm/${id}/days-off`, data)
    },
    deleteDayOff(bmID, id) {
        ApiService.setHeader()
        return ApiService.delete(`bm/${bmID}/days-off/${id}`)
    },

    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('bm', slug, data)
    },
    save_image(id, file){
        ApiService.setHeader()
        let formData = new FormData();
        formData.append("file", file);
        return ApiService.postFile('bm/'+id+'/image', formData)
    },
    active(id) {
        ApiService.setHeader()
        return ApiService.update(`bm/${id}/active`)
    },
    inactive(id) {
        ApiService.setHeader()
        return ApiService.update(`bm/${id}/inactive`)
    },
    delete(slug) {
        ApiService.setHeader()
        return ApiService.delete(`bm/${slug}`)
    }
}